<template>
  <div v-if="internalAffair">
    <card class="card" title="Dados do Atendimento (ouvidoria)">
      <div>
        <form @submit.prevent="submit">
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Nome do cliente"
                v-model="internalAffair.name"
                disabled
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input type="text" label="CPF" v-model="internalAffair.cpf" disabled></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="number"
                label="Nº Protocolo"
                v-model="internalAffair.protocol"
                disabled
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <fg-input type="text" label="Status" v-model="internalAffair.status" disabled></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input type="date" label="Data de criação" v-model="internalAffair.createdAt.split('T')[0]" disabled></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Mensagem do cliente</label>
                <textarea
                  rows="5"
                  class="form-control border-input"
                  v-model="internalAffair.message"
                  disabled
                ></textarea>
              </div>
            </div>
          </div>

          <hr />
          <br />
          <span>Direcionar Tratamento ou Finalizar Atendimento</span>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Selecione abaixo a opção desejada</label
                >
                <select v-model="actionType" :disabled="internalAffair.status === 'resolved'" class="form-control input i-width" required>
                  <option :value="null" selected disabled>Selecione...</option>
                  <option :value="'in_progress'" v-show="internalAffair.status === 'pending'">Direcionar Tratamento</option>
                  <option :value="'resolved'">Finalizar Atendimento</option>
                </select>
              </div>
            </div>
            <div class="col-md-3" v-show="actionType === 'in_progress' || !!internalAffair.operatorNameInProgress">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Responsável pelo tratamento</label
                >
                <select v-model="operatorName" class="form-control input i-width" :disabled="!!internalAffair.operatorNameInProgress">
                  <option :value="null" selected disabled>Selecione...</option>
                  <option :value="'Wellington'">Wellington</option>
                  <option :value="'Gustavo'">Gustavo</option>
                  <option :value="'Flávia'">Flávia</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3" v-show="internalAffair.operatorNameResolved">
              <fg-input type="text" label="Responsável por finalizar" v-model="internalAffair.operatorNameResolved" disabled></fg-input>
            </div>
            <div class="col-md-3" v-if="internalAffair.inProgressDate">
              <fg-input type="date" label="Data de direcionamento" :value="internalAffair.inProgressDate.split('T')[0]" disabled></fg-input>
            </div>
            <div class="col-md-3" v-if="internalAffair.resolvedDate">
              <fg-input type="date" label="Data atendimento finalizado" :value="internalAffair.resolvedDate.split('T')[0]" disabled></fg-input>
            </div>
          </div>

          <div class="row" v-if="internalAffair.messageInProgress">
            <div class="col-md-12">
              <div class="form-group">
                <label>Mensagem de direcionamento</label>
                <textarea rows="5" class="form-control border-input" :value="internalAffair.messageInProgress" disabled></textarea>
              </div>
            </div>
          </div>

          <div class="row" v-if="internalAffair.messageResolved">
            <div class="col-md-12">
              <div class="form-group">
                <label>Mensagem de atendimento finalizado</label>
                <textarea rows="5" class="form-control border-input" :value="internalAffair.messageResolved" disabled></textarea>
              </div>
            </div>
          </div>

          <div class="row" v-show="internalAffair.status !== 'resolved'">
            <div class="col-md-12">
              <div class="form-group">
                <label>Mensagem</label>
                <textarea v-model="message" rows="5" class="form-control border-input" required></textarea>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>

          <div class="container_buttons">
            <button class="btn-custom btn-salvar" name="tratamento" v-show="internalAffair.status !== 'resolved'">
              Concluir
            </button>
          </div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["fetchInternalAffair", "resolveInternalAffair", "inProgressInternalAffair"]),
    async submit() {
      try {
        switch (this.actionType) {
          case 'resolved':
            await this.resolveInternalAffair({
              id: this.$route.params.id,
              message: this.message,
              operatorName: this.operatorName,
            });
            break;
          case 'in_progress':
            await this.inProgressInternalAffair({
              id: this.$route.params.id,
              message: this.message,
              operatorName: this.operatorName,
            });
            break;
        }
        await Swal.fire({
          title: "Sucesso!",
          text: "Atendimento processado com sucesso.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        window.location.reload();
      } catch (err) {
        await Swal.fire({
          title: "Erro!",
          text: "Não foi possível processar o atendimento.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    }
  },
  data() {
    return {
      internalAffair: null,
      actionType: null,
      operatorName: null,
      message: ''
    }
  },
  async mounted() {
    try {
      this.internalAffair = await this.fetchInternalAffair({ id: this.$route.params.id });
      this.operatorName = this.internalAffair.operatorNameInProgress
    } catch (err) {
      await Swal.fire({
        title: "Erro!",
        text: "Não foi possível carregar os dados do atendimento.",
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  font-size: 22px;
  font-weight: bold;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;
    &:hover {
      background: #c07e03;
    }
  }

  &.btn-gerenet {
    margin-left: 10px;
    background: #2c69c5;
    &:hover {
      background: #1e4e97;
    }
  }

  &.btn-interesse {
    margin-left: 10px;
    background: #b80a0a;
    &:hover {
      background: #700202;
    }
  }
}

@media (min-width: 768px) and (max-width: 1077px) {
  button.btn-custom.btn-interesse {
    margin-top: 20px !important;
  }
}

@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>
